import * as Sentry from '@sentry/react'
import React, { useEffect } from 'react'
import Navigator from './navigation/navigator'

import { initializeIcons } from '@verzekeringapp-mono/shared/src/utils/initialize_icons'
import EmergencyModalProvider from './providers/EmergencyModalProvider'
import ThemeColorProvider from './providers/ThemeColorProvider'
import { initialize } from '@verzekeringapp-mono/shared/src/utils/firebase'
import ErrorBoundary from './components/ErrorBoundary'
import { useAppDispatch, useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getUser } from '@verzekeringapp-mono/shared/src/state/selectors/user'
import useAgency from '@verzekeringapp-mono/shared/src/hooks/use_agency'
import { getSubdomain } from './utils/hostUtils'
import { setAgencyPrintout } from '@verzekeringapp-mono/shared/src/state/slices/agency_slice'

initializeIcons()

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [],
  tracesSampleRate: 0.2,
  environment: process.env.REACT_APP_APP_ENV
})

initialize()

function App () {
  const user = useAppSelector(getUser)
  const { getAgencyPrintout } = useAgency()
  const dispatch = useAppDispatch()

  useEffect(() => {
    const subDomain = getSubdomain()

    if (subDomain) {
      getAgencyPrintout(subDomain)
    } else {
      dispatch(setAgencyPrintout(undefined))
    }
  }, [])

  return (
    <ErrorBoundary isLoggedIn={!!user}>
      <EmergencyModalProvider>
        <ThemeColorProvider>
          <Navigator />
        </ThemeColorProvider>
      </EmergencyModalProvider>
    </ErrorBoundary>
  )
}

export default App
